<template>
  <div>
    <BookingDetailsPanel />
    <p class="mt-4">
      If you cancel your appointment, there may be a delay in the availbility of a new appointment.
      If you still wish to cancel your appointment, click 'Confirm Cancellation'.
    </p>
    <div class="text-center btn-container">
      <LoadingBusy :loading="loading" :isAuthenticating="false" text="Loading, please wait...">
      </LoadingBusy>
      <v-layout row flex>
        <v-flex sm6 class="pa-1">
          <v-btn class="ma-2" color="primary" @click="nextPage('ViewExistingPage')"
            ><v-icon>mdi-arrow-left</v-icon>
            PREVIOUS
          </v-btn>
        </v-flex>
        <v-flex sm6 class="pa-1">
          <v-btn class="ma-2" color="primary" @click="nextClick()"
            ><v-icon>mdi-cancel</v-icon>
            CONFIRM CANCELLATION
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <v-alert
        class="ma-2"
        type="error"
        :value="isError"
        dense
        outlined
        dismissible
        transition="scale-transition"
      >
        {{ errorMessage }}
      </v-alert>
    </div>
  </div>
</template>

<script>
import BookingDetailsPanel from '@/components/BookingDetailsPanel.vue';
import { mapGetters } from 'vuex';
import LoadingBusy from '../components/LoadingBusy.vue';
import scApi from '../api/scApi';

export default {
  components: {
    BookingDetailsPanel,
    LoadingBusy,
  },
  data() {
    return {
      loading: false,
      isError: false,
      errorMessage: '',
    };
  },
  methods: {
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    async nextClick() {
      console.log('Cancel appointment');
      this.loading = true;
      try {
        const response = await scApi.CancelBooking(
          this.confirmationNumber,
          this.firstName,
          this.lastName,
          this.dateOfBirth,
          this.dLNumber,
        );
        console.log(response);
        this.$emit('navigateTo', 'CancelConfirmationPage');
        // if (response.ErrorMessage === null) {
        //   this.$emit('navigateTo', 'CancelConfirmationPage');
        // } else {
        //   console.log(response.ErrorMessage);
        // }
      } catch (error) {
        console.log(error);
        this.isError = true;
        this.errorMessage = error;
      } finally {
        console.log('Inside NewBooking finally');
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters('userInfo', ['dLNumber', 'firstName', 'lastName', 'dateOfBirth']),
    ...mapGetters('bookingDetails', ['confirmationNumber']),
  },
};
</script>

<style>
.fixedButtonSize {
  height: 45px;
  width: 250px;
}
</style>
